import { render, staticRenderFns } from "./AuthorList.vue?vue&type=template&id=2f12b77c&scoped=true"
import script from "./AuthorList.vue?vue&type=script&lang=js"
export * from "./AuthorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f12b77c",
  null
  
)

export default component.exports